import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom"; 
import { fetchApi } from "./redux/api";
import { formatNumber } from "./redux/utils";

const FinancialRevenueTable = () => {
  const location = useLocation();
  const { note, description, economicCode } = location.state || {};
const [notes, setNotes] = useState([]);

const codes = location.state?.economicCode;
// const note = location.state?.economicCode;

  useEffect(() => {
    fetchApi(`get_cash_report?query_type=notes&code=${codes}`)
      .then((data) => {
        console.log(data);
        setNotes(data.result);
      })
      .catch((err) => {
        console.log(err);
      });
    }, []);

  const groupedData = [
    {
      Notes: 8,
      Code: "210201",
      Description: "Salaries, Wages and Employee benefits",
      Items: [
        {
          Codes: "21020101",
          Description: "Staff costs - Salaries and wages",
          year2023: 65392942,
          year2022: 61747003,
        },
        {
          Codes: "21020102",
          Description: "Social benefits - Revenue (PFC) charges",
          year2023: 8882494,
          year2022: 7474948,
        },
      ],
      SubItems: [
        {
          Notes: "8i",
          Code: "",
          Description: "Note*",
          SubCategories: [
            {
              Type: "Add",
              Items: [
                {
                  Codes: null,
                  Description: "Salary arrears settled in 2022",
                  year2023: 12000,
                  year2022: 0,
                },
              ],
            },
            {
              Type: "Less",
              Items: [
                {
                  Codes: null,
                  Description: "Salary Overpaid in 2022 Refunded in 2023",
                  year2023: 45000,
                  year2022: 30000,
                },
              ],
            },
          ],
          Items: [
            {
              Codes: null,
              Description:
                "Total Salaries, Wages & Employee Benefits for the year 2023",
              year2023: 74275436,
              year2022: 69221951,
            },
          ],
        },
      ],
    },
    {
      Notes: 9,
      Code: "220201",
      Description: "Transport & Travel (General)",
      Items: [
        {
          Codes: "22020101",
          Description: "Transport & Travel - Training",
          year2023: 733178,
          year2022: 785154,
        },
        {
          Codes: "22020103",
          Description: "Local Travel & Transport - Others",
          year2023: 1321540,
          year2022: 1353540,
        },
        {
          Codes: "22020104",
          Description: "International Travel & Transport - Training",
          year2023: 651654,
          year2022: 681554,
        },
        {
          Codes: "22020105",
          Description: "International Travel & Transport - Others",
          year2023: 232237,
          year2022: 262237,
        },
      ],
    },
  ];

  const calculateTotals = (items) => {
    return items.reduce(
      (acc, curr) => {
        acc.year2023 += curr.year2023 || 0;
        acc.year2022 += curr.year2022 || 0;
        return acc;
      },
      { year2023: 0, year2022: 0 }
    );
  };


  return (
    <div className="container-fluid py-5">
      {/* {JSON.stringify(location.state)} */}
      <style>
        {`
                  
            h1{
            color: #177e89;
            font-size: 22px;
            margin: 0;
            padding: 0;
            }
            header {
            background: linear-gradient(to right, #bc5449, white);
            padding: 40px 50px 2px 50px;
            border-bottom: 4px solid #2E8B57;
            margin-bottom: 15px;
            }
            footer {
            background: linear-gradient(to right, #420D09, #990f02);
            padding: 20px;
            }
                  `}
      </style>
      <header>
        Report of the Accountant General with IPSAS Accrual Financial Statements
        for the Year Ended 31st December, 2023
      </header>
      <h2>Notes to the Financial Statements</h2>
      <Table striped bordered className="financial-table">
        <thead>
          <tr>
            <th>Notes</th>
            <th>Codes</th>
            <th>Description</th>
            <th>31 Dec 2023 (₦'000)</th>
            <th>31 Dec 2022 (₦'000)</th>
          </tr>
        </thead>
        <tbody>
        {notes?.map((group, index) => {
            // const totals = calculateTotals(group.amount);
            return (
              <React.Fragment key={index}>
                <tr>
                  <td className="text-center">
                    <b>{note}</b>
                  </td>
                  <td className="text-center">
                    {group.code}
                  </td>
                     <td colSpan="">
                    {group.account_description}
                  </td>
                      <td className="text-center">
                    <b>{formatNumber(group.amount)}</b>
                  </td>
                      <td className="text-center">
                    <b>{formatNumber(group.amount)}</b>
                  </td>
               
                  
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td>
                    <b>Total {formatNumber(group.amount)}</b>
                  </td>
                  <td
                    className="text-right"
                    style={{
                      borderTop: "3px solid black",
                      borderBottom: "3px solid black",
                    }}
                  >
                    <b></b>
                  </td>
                  <td
                    className="text-right"
                    style={{
                      borderTop: "3px solid black",
                      borderBottom: "3px solid black",
                    }}
                  >
                    <b>{formatNumber(group.amount)}</b>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
      <footer>
        <div
          style={{
            background: "white",
            padding: "5px",
            width: "30px",
            height: "30px",
            textAlign: "center",
          }}
        >
          1
        </div>
      </footer>
    </div>
  );
};

export default FinancialRevenueTable;
